export const FOLIO_LIST_KARVY = "FOLIO_LIST_KARVY";
export const FOLIO_LIST_KARVY_RESPONSE = "FOLIO_LIST_KARVY_RESPONSE";
export const FOLIO_LIST_KARVY_FAILED = "FOLIO_LIST_KARVY_FAILED";

export const GET_REGISTERED_BANKS = "GET_REGISTERED_BANKS";
export const GET_REGISTERED_BANKS_RESPONSE = "GET_REGISTERED_BANKS_RESPONSE";
export const GET_REGISTERED_BANKS_FAILED = "GET_REGISTERED_BANKS_FAILED";

export const ORDER_GENERATION = "ORDER_GENERATION";
export const ORDER_GENERATION_RESPONSE = "ORDER_GENERATION_RESPONSE";
export const ORDER_GENERATION_FAILED = "ORDER_GENERATION_FAILED";

export const PAYMENT_REQUEST = "PAYMENT_REQUEST";
export const PAYMENT_REQUEST_RESPONSE = "PAYMENT_REQUEST_RESPONSE";
export const PAYMENT_REQUEST_FAILED = "PAYMENT_REQUEST_FAILED";

export const GET_PG_RESPONSE = "GET_PG_RESPONSE";
export const GET_PG_RESPONSE_RESPONSE = "GET_PG_RESPONSE_RESPONSE";
export const GET_PG_RESPONSE_FAILED = "GET_PG_RESPONSE_FAILED";

export const VALIDATE_BROKER_CODE = "VALIDATE_BROKER_CODE";
export const VALIDATE_BROKER_CODE_RESPONSE = "VALIDATE_BROKER_CODE_RESPONSE";
export const VALIDATE_BROKER_CODE_FAILED = "VALIDATE_BROKER_CODE_FAILED";

export const FOLIO_BROKER_LIST = "FOLIO_BROKER_LIST";
export const FOLIO_BROKER_LIST_RESPONSE = "FOLIO_BROKER_LIST_RESPONSE";
export const FOLIO_BROKER_LIST_FAILED = "FOLIO_BROKER_LIST_FAILED";

export const UPDATE_FOLIO_BROKER_LIST = "UPDATE_FOLIO_BROKER_LIST";

export const BUCKET_ID = "BUCKET_ID";
export const BUCKET_ID_RESPONSE = "BUCKET_ID_RESPONSE";
export const BUCKET_ID_FAILED = "BUCKET_ID_FAILED";

export const DIT_URL_DETAILS = "DIT_URL_DETAILS";
export const DIT_URL_DETAILS_RESPONSE = "DIT_URL_DETAILS_RESPONSE";
export const DIT_URL_DETAILS_FAILED = "DIT_URL_DETAILS_FAILED";

export const SELECTED_OPTION = "SELECTED_OPTION";
export const RESET_SELECTED_FUND = "RESET_SELECTED_FUND";

export const UPDATE_URL_DETAILS_FOR_QUICK_INVEST = "UPDATE_URL_DETAILS_FOR_QUICK_INVEST";

export const UPDATE_CART_ITEM_BY_SCHEME_CODE = "UPDATE_CART_ITEM_BY_SCHEME_CODE";

export const UPDATE_CART_ORDER_REVIEW_ITEM_BY_SCHEME_CODE = "UPDATE_CART_ORDER_REVIEW_ITEM_BY_SCHEME_CODE";

export const PAYMENT_CHECK_MODE = "PAYMENT_CHECK_MODE";
export const PAYMENT_CHECK_NAME = "PAYMENT_CHECK_NAME";

